const WaitVote = () => {
  document.body.addEventListener("click", (event) => {
    const { target } = event;

    if (target.classList.contains("js-like-button") || target.classList.contains("js-dislike-button")) {
      target.classList.add("js-waiting-response")
      const icon = target.querySelector(".js-icon")
      if(icon) {
        icon.classList.remove("a-icon-heart", "a-icon-heart--solid")
        icon.classList.add("a-icon-spinner", "fa-spin")
      }
    }
  });
};

WaitVote();
